export const simpleTemplateFields = [
  "hideDate",
  "oeuvresDescriptionEnsemble",
  "photosDescriptionLocalisation",
  "photosDescriptionRangement",
] as const;

export type PhotographyPrintSettings = Record<
  (typeof simpleTemplateFields)[number],
  boolean
>;
